import { useEffect, useState } from 'react';
import Input from 'components/Basic/Input';
import { inchesToMeters, metersToInches } from 'unit.utils';
import { DivInputWithUnit, DivRowHeight, DivFieldError } from './style';

const MAX_ROW_SPACING_IN = 240;

type Props = {
	value?: number;
	onChange: (value: number) => void;
	disabled?: boolean;
	singleField?: boolean;
};

const toInchesDisplay = (m?: number) => `${m !== undefined ? metersToInches(m) : ''}`;

export default function RowSpacing({ value, onChange, disabled, singleField }: Props) {
	const [localValueInInches, setLocalValue] = useState(toInchesDisplay(value));
	const [error, setError] = useState(false);

	useEffect(() => {
		setLocalValue(toInchesDisplay(value));
	}, [value]);

	function handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
		const raw = evt.target.value;
		setLocalValue(raw);

		if (!raw) {
			setError(false);
			onChange(NaN);
			return;
		}

		const inches = +raw;
		const isOverLimit = inches > MAX_ROW_SPACING_IN;
		setError(isOverLimit);
		onChange(isOverLimit ? NaN : inchesToMeters(inches));
	}

	function handleBlur() {
		const inches = +localValueInInches;
		if (!localValueInInches.trim() || !Number.isFinite(inches)) {
			setLocalValue(toInchesDisplay(value));
			setError(false);
			return;
		}
		if (inches > MAX_ROW_SPACING_IN) {
			setLocalValue(`${MAX_ROW_SPACING_IN}`);
			onChange(inchesToMeters(MAX_ROW_SPACING_IN));
			setError(false);
		}
	}

	return (
		<DivRowHeight className={`row-spacing${singleField ? ' single-field-wrap' : ''}${error ? ' error' : ''}`}>
			<label>Row Spacing:</label>
			<DivInputWithUnit $stretch={singleField} className={error ? 'error' : ''}>
				<Input
					type="number"
					step="any"
					min={0}
					value={localValueInInches}
					onChange={handleChange}
					onBlur={handleBlur}
					onKeyUp={(e) => e.stopPropagation()}
					disabled={disabled}
				/>
				<span className='unit'>in</span>
			</DivInputWithUnit>
			{error && <DivFieldError>{`Must be <= ${MAX_ROW_SPACING_IN}`}</DivFieldError>}
		</DivRowHeight>
	);
}
